(function () {
    'use strict';

    angular
        .module('app')
        .factory('sidebarservice', sidebarservice);

    sidebarservice.$inject = ['$http', '$window', '$q', '$filter', '$timeout', 'loginService', '$localStorage'];

    function sidebarservice($http, $window, $q, $filter, $timeout, loginService, $localStorage) {

        var leftSideBarOpen = true;

        if ($localStorage.perUserSettings) {
            if ($localStorage.perUserSettings[loginService.id])
                leftSideBarOpen = $localStorage.perUserSettings[loginService.id].leftSideBarOpen === undefined ? true : $localStorage.perUserSettings[loginService.id].leftSideBarOpen;
        }
        

        if (bowser.android || bowser.ios) {
            leftSideBarOpen = false;
        }

        var service = {
            leftSideBarCollapse: false,
            leftSideBarOpen: leftSideBarOpen,
            rightSideBarOpen: false,
            rightSideBarMode: 0, // 2016-10-20
            rightSideBarParent: null, // 2016-10-20
            fileGuideCollapse: true,
            showDataToolBox: false,
            ftsEnabled: false,
            activeMenuItem: null,
            databaseType: 1,
            rightSideBarElementMode: "over",
            checkFTS: checkFTS,
            getDatabaseType: getDatabaseType,
            toggleRightSidebar: toggleRightSidebar,
            sideMenuItems: {
                favorites: { active: false, items: [] },
                savedSearches: { active: false, items: [] },
                fileGuide: { active: false, items: [] },
                //supportLibraries: { active: false, items: [] },
                workAreas: { active: false, items: []}
            },
            getChildren: getChildren,
            setManualRelationships: setManualRelationships,
            //getSupportLibraries: getSupportLibraries,
            //getSupportLibraryMapping: getSupportLibraryMapping,
            //setSupportLibraryMapping: setSupportLibraryMapping,
            menuItems: [],
            openMenuItem: openMenuItem
        };

        return service;


        function openMenuItem(menuName) {
            var menuItem = $filter('filter')(service.menuItems, { name: menuName })[0];
            menuItem.action(menuItem);
        }
        

        function checkFTS() {
            var deferred = $q.defer();
            $http.get('/Synergis.WebApi/Api/adminoptions/ftsenabled').then(function (response) {
                service.ftsEnabled = response.data;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getDatabaseType() {
            var deferred = $q.defer();
            $http.get('/Synergis.WebApi/Api/databasetype').then(function (response) {
                service.databaseType = response.data;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getChildren(tableNumber, fileId, majRev, minRev) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/Relationships/Children/';
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev)
            $http.get(url).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function setManualRelationships(tableNumber, fileId, majRev, minRev, children) {
            var deferred = $q.defer();
            // bill 08-31-2018 Misspelled controller URL var url = '../Synergis.WebApi/api/Relationships/ManualRelationshpis/';
            var url = '../Synergis.WebApi/api/Relationships/Manual/';

            //Bill 08-31-2018 #25767 PW-P2A is not creating a fixed relationship as it should
            //     Added fixFloat parameter to WebAPI controller, passing in an illegal value of '0' to use the system defaults
            //     Legal values are fi(x), floa(T), (D)ock
            url = url.concat(tableNumber + '/' + fileId + '/' + majRev + '/' + minRev + "/0");

            var request = $http({
                method: 'POST',
                url: url,
                data: children,
            }).then(function (response, status, headers, cfg) {
                deferred.resolve(response.data);
            }, function (err, status) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function toggleRightSidebar(mode) {
            var delay = 0;
            var modes = ["over", "push"];

            if (service.rightSideBarOpen) {
                if (mode == service.rightSideBarMode) {
                    service.rightSideBarOpen = false;
                }
            }
            else {
                service.rightSideBarElementMode = modes[mode];
                service.rightSideBarMode = mode;
                service.rightSideBarOpen = true;

                if (bowser.android || bowser.ios) {
                    service.leftSideBarOpen = false;
                }

            }
            
        }


        // ************************************************
        // Support Libraries - Begin
        // ************************************************
        /*
        function getSupportLibraries() {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SupportLibraries';
            $http.get(url).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getSupportLibraryMapping(libId) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SupportLibraries/';
            url = url.concat(libId);
            $http.get(url).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function setSupportLibraryMapping(libId, mappedPath) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/SupportLibraries/';
            url = url.concat(libId);
            var request = $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(mappedPath),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response, status, headers, cfg) {
                deferred.resolve(response.data);
            }, function (err, status) {
                deferred.reject(err);
            });
            return deferred.promise;
        }
        */
        // ************************************************
        // Support Libraries - End
        // ************************************************



        
    }
})();